import { Box } from '@chakra-ui/react';
import { Editor, Range } from '@tiptap/react';
import { renderToString } from 'react-dom/server';

type InsertSlashCommandChipArgs = {
  editor: Editor;
  item: string;
  icon?: string;
  range?: Range;
};

export function insertSlashCommandChip({
  editor,
  item,
  icon,
  range,
}: InsertSlashCommandChipArgs) {
  let iconHtml = '';
  if (icon) {
    iconHtml = renderToString(
      <Box
        style={{
          mask: `url(${icon}) no-repeat center / contain;`,
          backgroundColor: 'currentColor',
          height: '11px',
          width: '11px',
        }}
      />
    );
  }

  const chain = editor.chain().focus();
  if (range) {
    chain.deleteRange(range);
  }

  chain
    .insertContent(
      `<span data-type="slash-command">${
        iconHtml ? `<span data-svg-node>${iconHtml}</span>` : ''
      }${item}</span> `
    )
    .run();
}
